// extracted by mini-css-extract-plugin
export default {"menu":"contacts_menu__Q+wNc"};